import { render, staticRenderFns } from "./SubjectImport.vue?vue&type=template&id=2df8fdc6"
import script from "@/controllers/subject/subject-import.js?vue&type=script&lang=js&external"
export * from "@/controllers/subject/subject-import.js?vue&type=script&lang=js&external"
import style0 from "./SubjectImport.vue?vue&type=style&index=0&id=2df8fdc6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports